import { Box, Button, Flex, Heading, Image, Text, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../../../../helper/utils/navigation';
import getStaticAsset from '../../../../../helper/utils/utilsStaticAsset';
import CustomerVerif from './CustomerVerif';

export default function CustomerInformation({ isPartyMenu = false }) {
    const navigate = useNavigate();

    const { isOpen: isOpenVerif, onToggle: onOpenVerif, onClose: onCloseVerif } = useDisclosure();
    const { loadingWaiver = false, isVerifiedWaiver = false, waiver } = useSelector((s) => s?.waiver);

    if (isVerifiedWaiver) {
        return (
            <Box w='full' rounded='lg' bg='primary.50' p={5} py={7} my={12} border='1px' borderColor='primary.200'>
                <Heading fontSize={{ base: 'lg', md: 'xl' }} color='gray.600' fontWeight={500} mb={1}>
                    Hello.
                </Heading>
                <Heading fontSize={{ base: 'xl', md: '2xl' }} textTransform='capitalize'>
                    Welcome, {waiver['fullname'] || ''}!
                </Heading>
                <Text color='gray.600' mt={3} lineHeight={1.3}>
                    {isPartyMenu ? 'Please ensure that you arrive on your scheduled date and time.' : 'Enter Anytime on Your Selected Date! Entry gates open every hour from 10:00 to 20:00 (10:00, 11:00, 12:00, up to 20:00). Arrive whenever suits you best on the date of your visit!'}
                </Text>
            </Box>
        );
    }

    return (
        <>
            <Box w='full' rounded='lg' bg='primary.50' p={5} py={7} my={12} border='1px' borderColor='primary.200'>
                <Flex w='full' alignItems='center' justifyContent='center' gap={3}>
                    <Image src={getStaticAsset('[PPI] Logo.png')} w='80px' h='90%' fit='contain' mb={3} />
                    <Image src={getStaticAsset('[SPI] Logo_Purple.png')} w='80px' h='90%' fit='contain' mb={3} />
                    <Image src={getStaticAsset('[TSI] Logo.png')} w='80px' h='90%' fit='contain' mb={3} />
                </Flex>
                <Heading fontSize={{ base: 'xl', md: '2xl' }} textAlign='center'>
                    First time in our park?
                </Heading>
                <Text fontSize='md' color='black' lineHeight='1.3' mb={5} textAlign='center'>
                    Before proceeding with the transaction, please log in to your account.
                </Text>
                <Flex w='full' alignItems='center' justifyContent='center' flexDirection={{ base: 'column', md: 'row' }} mt={7} gap={{ base: 2, md: 4 }}>
                    <Button
                        size='lg'
                        w={{ base: 'full', md: 'max-content' }}
                        variant='solid'
                        colorScheme='primary'
                        fontSize='15px'
                        fontWeight={600}
                        isLoading={loadingWaiver}
                        onClick={() => {
                            onOpenVerif();
                            navigate(urlNavigate('waiver', `user?return-url=${window.location.pathname}`));
                        }}>
                        YES
                    </Button>
                    <Text fontSize='14px' color='gray.500'>
                        Or
                    </Text>
                    <Button
                        size='lg'
                        w={{ base: 'full', md: 'max-content' }}
                        variant='outline'
                        colorScheme='red'
                        fontSize='15px'
                        fontWeight={600}
                        onClick={() => {
                            onOpenVerif();
                        }}>
                        NO
                    </Button>
                </Flex>
            </Box>
            <Box w='full' mb={8}>
                <CustomerVerif isOpen={isOpenVerif} onClose={onCloseVerif} />
            </Box>
        </>
    );
}
